import React, { useEffect } from 'react';
import { AccordionSummary, AccordionDetails } from '@mui/material';

import StyledAccordion from './styles';
import GenericEntry from '../GenericSection/components/GenericEntry';
import { IGenericEntry } from '../../interfaces/IGenericSection';
import InnerExpandIcon from '../../assets/icons/inner-expand.svg';

interface IInnerAccordionProps {
  title: string;
  description?: IGenericEntry;
  height?: number;
  setHeight?: CallableFunction;
  children?: React.ReactNode;
}

const InnerAccordion: React.FC<IInnerAccordionProps> = ({
  height,
  title,
  description,
  setHeight,
  children
}) => {
  useEffect(() => {
    if (setHeight) {
      setHeight(height);
    }
  }, [height, setHeight]);

  return (
    <StyledAccordion className='accordion--angular'>
      <AccordionSummary
        expandIcon={<img src={InnerExpandIcon} alt='Expand' />}
        className='inner-accordion__summary accordion__summary--outlined'
      >
        <h4>{title}</h4>
        {description && (
          <GenericEntry code={description.code} value={description.value} />
        )}
      </AccordionSummary>
      <AccordionDetails className='inner-accordion__details accordion__details--display-column'>
        {children}
      </AccordionDetails>
    </StyledAccordion>
  );
};

InnerAccordion.defaultProps = {
  setHeight: undefined,
  description: undefined
};

export default InnerAccordion;
